import { render, staticRenderFns } from "./preSale-delivery-detail.vue?vue&type=template&id=2b73fba4&scoped=true"
import script from "./preSale-delivery-detail.vue?vue&type=script&lang=js"
export * from "./preSale-delivery-detail.vue?vue&type=script&lang=js"
import style0 from "./preSale-delivery-detail.vue?vue&type=style&index=0&id=2b73fba4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b73fba4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b73fba4')) {
      api.createRecord('2b73fba4', component.options)
    } else {
      api.reload('2b73fba4', component.options)
    }
    module.hot.accept("./preSale-delivery-detail.vue?vue&type=template&id=2b73fba4&scoped=true", function () {
      api.rerender('2b73fba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/preSale-management/delivery-revoke-records/preSale-delivery-detail.vue"
export default component.exports